import { useEffect, useState } from "react";
import navtoggle from "../assets/menu.svg";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import coin from '../assets/coin.png'
import logo from '../assets/Quiz Logo.svg'
import AdRewardModal from "./AdRewardModal";
import { getCoins } from "../utils/coins";

function Navbar() {
  const [show, setShow] = useState(false);
  const [coins, setCoins] = useState(getCoins());
  const [showAd, setShowAd] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // keep the balance in sync whenever coins change anywhere in the app
  useEffect(() => {
    const sync = () => setCoins(getCoins());
    window.addEventListener("coinsUpdated", sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener("coinsUpdated", sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return (
    <>
      <div className="header-main position-relative d-flex justify-content-between ">
        <div>
          <img
            src={navtoggle}
            alt="Menu Icon"
            onClick={handleShow}
            style={{ cursor: "pointer", height: "30px" }}
          />
        </div>
        <div className="quiz-title">
          {/* <h4>Quiz Time</h4> */}
          <img src={logo} alt="icon" height={"35px"}/>
        </div>
        {/* <div className="coin-div">
          <img src={coin} alt="Coin" style={{ height: "20px" }} />
          <span>0</span>
        </div> */}
        <div className="coin-wrapper">
  <div className="plus-icon" onClick={() => setShowAd(true)}>+</div>

  <div className="coin-div">
    <img src={coin} alt="Coin" style={{ height: "20px" }} />
    <span>{coins}</span>
  </div>
</div>
      </div>

      <AdRewardModal
        show={showAd}
        onClose={() => setShowAd(false)}
        message="Click on video ad to get 100 reward coins."
      />

      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ backgroundColor: "#111317", color: "white" }}
        className="custom-offcanvas"
      >
        <Offcanvas.Header closeButton closeVariant="white" >
            <div>
                <img src={logo} alt="icon" height={"35px"}/>
            </div>
        </Offcanvas.Header>

        <Offcanvas.Body className="text-start">
          <ul className="d-flex flex-column justify-content-between gap-2 m-0 p-0">
            <li>
              <Link to="/" className="nav-link">
                Home
              </Link>
            </li>
            {/* <li>
              <Link to="/about" className="nav-link">
                About Us
              </Link>
            </li> */}
            <li>
              <Link to="/contact" className="nav-link">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="nav-link">
                Privacy Policy
              </Link>
            </li>
             <li>
              <Link to="/terms" className="nav-link">
                Terms & Conditions
              </Link>
            </li>
             <li>
              <Link to="/rule" className="nav-link">
                Contest Rules
              </Link>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default Navbar;
